import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import RankPodium from 'View/host-achievement-detail/component/rank-podium';

import styles from './styles.module.css';

export const SkeletonRankingPodium = () => {
  return (
    <Box className={styles['skeleton-ranking-podium__container']} data-testid="skeleton-ranking-podium__container">
      <Box marginBottom="12px">
        <Flex justifyContent="center" alignItems="end" marginTop="30px">
          <RankPodium rankPosition={2} />
          <RankPodium rankPosition={1} />
          <RankPodium rankPosition={3} />
        </Flex>
      </Box>
      <Box>
        <SkeletonComponent width="100%" height="42px" />
      </Box>
    </Box>
  );
};

export const SkeletonAchievementProgress = () => {
  return (
    <Box className={styles['skeleton-achievement-progress__container']} data-testid="skeleton-achievement-progress__container">
      <Box>
        <SkeletonComponent width="30%" height="16px" mb="4px" />
        <SkeletonComponent width="50%" height="16px" mb="4px" />
        <Flex gap="4px" alignItems="center" marginTop="6px">
          <SkeletonComponent width="90%" height="10px" mb="4px" />
          <SkeletonComponent width="10%" height="10px" mb="4px" />
        </Flex>
      </Box>
      <Box paddingBottom="16px" borderBottom="1px solid var(--color-neutral10)">
        <SkeletonComponent width="30%" height="16px" mb="4px" />
        <SkeletonComponent width="50%" height="16px" mb="4px" />
        <Flex gap="4px" alignItems="center" marginTop="6px">
          <SkeletonComponent width="90%" height="10px" mb="4px" />
          <SkeletonComponent width="10%" height="10px" mb="4px" />
        </Flex>
      </Box>

      <Flex flexDirection="column" gap="12px" paddingBottom="16px" borderBottom="1px solid var(--color-neutral10)">
        <Flex gap="16px">
          <Box flex={1}>
            <SkeletonComponent width="30%" height="14px" mb="4px" />
            <SkeletonComponent width="50%" height="14px" mb="4px" />
            <Flex gap="4px" alignItems="center" marginTop="6px">
              <SkeletonComponent width="80%" height="8px" mb="4px" />
              <SkeletonComponent width="20%" height="8px" mb="4px" />
            </Flex>
          </Box>
          <Box flex={1}>
            <SkeletonComponent width="30%" height="14px" mb="4px" />
            <SkeletonComponent width="50%" height="14px" mb="4px" />
            <Flex gap="4px" alignItems="center" marginTop="6px">
              <SkeletonComponent width="80%" height="8px" mb="4px" />
              <SkeletonComponent width="20%" height="8px" mb="4px" />
            </Flex>
          </Box>
        </Flex>
        <Flex gap="16px">
          <Box flex={1}>
            <SkeletonComponent width="30%" height="14px" mb="4px" />
            <SkeletonComponent width="50%" height="14px" mb="4px" />
            <Flex gap="4px" alignItems="center" marginTop="6px">
              <SkeletonComponent width="80%" height="8px" mb="4px" />
              <SkeletonComponent width="20%" height="8px" mb="4px" />
            </Flex>
          </Box>
          <Box flex={1}>
            <SkeletonComponent width="30%" height="14px" mb="4px" />
            <SkeletonComponent width="50%" height="14px" mb="4px" />
            <Flex gap="4px" alignItems="center" marginTop="6px">
              <SkeletonComponent width="80%" height="8px" mb="4px" />
              <SkeletonComponent width="20%" height="8px" mb="4px" />
            </Flex>
          </Box>
        </Flex>
      </Flex>

      <Flex>
        <Flex flex={1} flexDirection="column">
          <SkeletonComponent width="40%" height="14px" mb="4px" />
          <SkeletonComponent width="20%" height="14px" mb="4px" />
        </Flex>
        <Flex flex={1} flexDirection="column">
          <SkeletonComponent width="40%" height="14px" mb="4px" />
          <SkeletonComponent width="20%" height="14px" mb="4px" />
        </Flex>
      </Flex>
    </Box>
  );
};

const SkeletonHostAchievementDetail = () => (
  <Box className={styles['skeleton-host-achievement-detail__container']} data-testid="skeleton-host-achievement-detail__container">
    <SkeletonRankingPodium />
    <SkeletonAchievementProgress />
  </Box>
);

export default SkeletonHostAchievementDetail;
